module.exports = __webpack_public_path__ + "img/43_52.af669ea2.png";